// Back-compat only: the customer request detail moved from
// /account/requests/:id to the canonical tracking page /proforma/:token.
// An old link has the numeric id but not the token, so this fetches the
// request once (ownership-checked server-side) and forwards to
// /proforma/:trackingToken. A miss (not the caller's request, or gone)
// falls back to the request list at /track.

import { Navigate, useParams } from 'react-router-dom';
import PortalShell from '../components/PortalShell.jsx';
import LoadingState from '../components/LoadingState.jsx';
import { useMyRequestDetail } from '../hooks/useAccount.js';

export default function AccountRequestRedirect() {
  const { id } = useParams();
  const { data, isLoading, isError } = useMyRequestDetail(id);

  if (isLoading) {
    return (
      <PortalShell width="medium">
        <LoadingState />
      </PortalShell>
    );
  }
  if (isError || !data || !data.trackingToken) {
    return <Navigate to="/track" replace />;
  }
  return <Navigate to={`/proforma/${data.trackingToken}`} replace />;
}
